import styles from "./header.module.css";

const headerStyles = {
    container: `flex items-center justify-between w-full p-2 ${styles.container}`,
    // logo: `max-w-[150px] h-[30px] ${styles.logo}
    //         md:w-[166px] md:h-[41px] md:max-w-[unset]
    // `,
    logo: `w-[65px] h-[auto] max-w-full
          md:w-[95px]   
    `,
    header_btn: `${styles.header_btn}` ,
}

export { headerStyles }